import { TextField } from "@material-ui/core";
import NumberFormat from "react-number-format";
import { useState, useEffect } from "react";
import { cloneDeep } from "lodash";

function NumberFormatCustom(props) {

    const { inputRef, column, onChange, ...other } = props;

    const onChangeValue = ( value, sourceInfo ) => {

        if ( onChange ) {

            // change value only if user changed value ( prevent propagation of change from property value )

            if ( sourceInfo?.source === "event" ) {

                let event = cloneDeep ( sourceInfo.event );

                event.target.value = value.floatValue;
                onChange ( sourceInfo.event );

            }

        }

    }
    const thousandSeparator = column ? ( column.thousandSeparator !== undefined ? column.thousandSeparator : true ) : true;
    const decimalScale = column ? ( column.decimalScale !== undefined ? column.decimalScale : 4 ) : 4;
    const allowNegative = column ? ( column.allowNegative !== undefined ? column.allowNegative : true ) : true;

    return (
        <NumberFormat
            {...other}
            prefix={column?.numberPrefix}
            getInputRef={inputRef}
            onValueChange={onChangeValue}
            thousandSeparator={thousandSeparator}
            allowNegative={allowNegative}
            decimalScale={decimalScale}
        />
    );
}

function FilterFormItemFloat(props) {

    const { column, InputLabelProps, value, onChange, ...others } = props;
    
    const [floatValue, setFloatValue] = useState (  );

    useEffect(() => {

        let decimalScale = column ? ( column.decimalScale !== undefined ? column.decimalScale : 4 ) : 4;
        let initialValue = parseFloat ( value );
    
        setFloatValue ( isNaN ( initialValue ) ? 0.0 : initialValue );

    }, [column, value])

    useEffect(() => {

    }, [value])

    let textFieldProps = {

        InputLabelProps: {
            shrink: true,
            ...InputLabelProps,
        },

        onChange: ( event ) => {

            let floatValue = parseFloat ( event.target.value );

            setFloatValue ( floatValue );

            if ( onChange ) {

                setTimeout ( onChange ( floatValue ), 0 );

            }

        },
        ...others,
    };

    if (column.filter.InputLabelProps) {
        textFieldProps.InputLabelProps = { ...textFieldProps.InputLabelProps, ...column.InputLabelProps };
    }

    if (column.filter.variant) {
        textFieldProps.variant = column.variant;
    }

    if (column.filter.inputProps) {
        textFieldProps.inputProps = column.inputProps;
    }

    if (column.filter.InputProps) {
        textFieldProps.InputProps = { ...column.InputProps, inputComponent: NumberFormatCustom };
    } else {
        textFieldProps.InputProps = { inputComponent: NumberFormatCustom };
    }

    if (column.filter.InputProps) {
        textFieldProps.InputProps = column.InputProps;
    }

    if (column.filter.style) {
        textFieldProps.style = column.style;
    }

    return <TextField value={floatValue} {...textFieldProps} />;

}

export default FilterFormItemFloat;
